import "./Works.scss";

import bakorwilThumbnail from "../assets/images/bakorwilThumbnail.png";
import bbnThumbnail from "../assets/images/bbnThumbnail.png";
import project1Img from "../assets/images/project1home.png";
import project2Img from "../assets/images/project2home.png";
import project3Img from "../assets/images/project3home.png";
import project4Img from "../assets/images/project4home.png";

const Works = () => {
  return (
    <section className="works">
      <div className="works__container">
        <h1 className="works__title">
          All My Recent Works:<br />Ishvara Pranidhana Lakshmana
        </h1>
        
        <div className="works__grid">
          <span className="line"></span>

          <a href="/projects/bakorwilmalang" className="project-card">
            <div className="project-card__content">
              <div className="project-card__info">
                <h2 className="project-card__title">Official Website BAKORWIL III Malang</h2>
                <div className="project-card__tags">
                  <span className="project-card__tag">Website Development</span>
                  {/* <span className="project-card__tag">Development</span> */}
                </div>
                <div className="project-card__tags">
                  <span className="project-card__tag">Search Engine Optimization</span>
                  {/* <span className="project-card__tag">Engine</span>
                  <span className="project-card__tag">Optimization</span> */}
                </div>
                <div className="project-card__link">VIEW PROJECT</div>
              </div>
              <div className="project-card__image-container">
                <img src={bakorwilThumbnail|| "/placeholder.svg"} alt="Dancing Stars" className="project-card__image" />
              </div>
            </div>
          </a>

          <span className="line"></span>

          <a href="/projects/baksobakarnyonya" className="project-card">
            <div className="project-card__content">
              <div className="project-card__info">
                <h2 className="project-card__title">Bakso Bakar Nyonya Website</h2>
                <div className="project-card__tags">
                  <span className="project-card__tag">Website Development</span>
                  {/* <span className="project-card__tag">Development</span> */}
                </div>
                <div className="project-card__tags">
                  <span className="project-card__tag">Website Design</span>
                  {/* <span className="project-card__tag">Engine</span>
                  <span className="project-card__tag">Optimization</span> */}
                </div>
                <div className="project-card__link">VIEW PROJECT</div>
              </div>
              <div className="project-card__image-container">
                <img src={bbnThumbnail|| "/placeholder.svg"} alt="Dancing Stars" className="project-card__image" />
              </div>
            </div>
          </a>

          <span className="line"></span>

          <a href="/projects/laporkanapp" className="project-card">
            <div className="project-card__content">
              <div className="project-card__info">
                <h2 className="project-card__title">LaporkanApp</h2>
                <div className="project-card__tags">
                  <span className="project-card__tag">Website Development</span>
                </div>
                <div className="project-card__link">VIEW PROJECT</div>
              </div>
              <div className="project-card__image-container">
                <img src={project1Img || "/placeholder.svg"} alt="Dancing Stars" className="project-card__image" />
              </div>
            </div>
          </a>

          <span className="line"></span>

          <a href="/projects/haryaportfolio" className="project-card">
            <div className="project-card__content">
              <div className="project-card__info">
                <h2 className="project-card__title">Harya Pranatreshna</h2>
                <div className="project-card__tags">
                  <span className="project-card__tag">Website Development</span>
                </div>
                <div className="project-card__tags">
                  <span className="project-card__tag">Website Design</span>
                </div>
                <div className="project-card__link">VIEW PROJECT</div>
              </div>
              <div className="project-card__image-container">
                <img src={project2Img || "/placeholder.svg"} alt="Enjoy Silence" className="project-card__image" />
              </div>
            </div>
          </a>

          <span className="line"></span>

          <a href="/projects/vartimes" className="project-card">
            <div className="project-card__content">
              <div className="project-card__info">
                <h2 className="project-card__title">Vartimes</h2>
                <div className="project-card__tags">
                  <span className="project-card__tag">Website Development</span>
                </div>
                <div className="project-card__tags">
                  <span className="project-card__tag">Website Design</span>
                </div>
                <div className="project-card__link">VIEW PROJECT</div>
              </div>
              <div className="project-card__image-container">
                <img src={project3Img || "/placeholder.svg"} alt="Pure Vision" className="project-card__image" />
              </div>
            </div>
          </a>

          <span className="line"></span>

          <a href="/projects/quizwizz" className="project-card">
            <div className="project-card__content">
              <div className="project-card__info">
                <h2 className="project-card__title">QuizWizz</h2>
                <div className="project-card__tags">
                  <span className="project-card__tag">Java App Development</span>
                </div>
                <div className="project-card__link">VIEW PROJECT</div>
              </div>
              <div className="project-card__image-container">
                <img src={project4Img || "/placeholder.svg"} alt="Modern Craft" className="project-card__image" />
              </div>
            </div>
          </a>
        </div>
      </div>
      <div className="footer">
        <p>&copy; 2025 Var11able. All rights reserved.</p>
        <p><a href="https://github.com/var11able" target="_blank" rel="noopener noreferrer">GitHub</a></p>
      </div>
    </section>
  );
};

export default Works;


